//hook
import { UserConsumer } from '../hooks/context/UserContext';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

//mui icon
import WarningIcon from '@mui/icons-material/Warning';

//translate
import { useTranslation } from 'react-i18next';

interface deleteCongirmationProps {
openDeleteConfirmation: boolean 
setOpenDeleteConfirmation: (openDeleteConfirmation: boolean) => void
id?: number
deleteFunction: (id: number) => Promise<any>
deleteLoading: boolean
recallFunction: () => Promise<any>
setData: (data: any) => void
}

const DeleteConfirmation = ({openDeleteConfirmation, setOpenDeleteConfirmation, id, deleteFunction, deleteLoading, recallFunction, setData}: deleteCongirmationProps) => {
    const {t} = useTranslation();
    const {theme} = UserConsumer()

    //start functions

    const handleDelete = async (id: number | undefined) => {
        if (id) {
            let result = await deleteFunction(id)
            if (result.code === 200) {
                let result = await recallFunction();
                setData(result.data);
            }
        }
        setOpenDeleteConfirmation(false)
    }

    //end functions

    return (
    <>
        <Dialog
        open={openDeleteConfirmation}
        onClose={()=>setOpenDeleteConfirmation(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
            <DialogTitle className='!flex items-center gap-2'>
                <div className={`p-2 flex items-center rounded-lg ${theme === "client" ? "!bg-green-200" : "!bg-orange-200"}`}>
                    <WarningIcon className={theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}/>
                </div>
                <p>{t("delete_confirmation")}</p>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                {t("delete_account")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className={`${theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}`} onClick={()=>setOpenDeleteConfirmation(false)}>{t("cancel")}</Button>
                <Button 
                onClick={()=>handleDelete(id)}
                className={`!text-white ${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"}`} 
                autoFocus
                >
                {deleteLoading
                ? <CircularProgress className='w-1 h-1'/>
                :t("confirm")
                }
                </Button>
            </DialogActions>
        </Dialog>
    </>
    )
}

export default DeleteConfirmation